module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bJoaZ5/tc-custom/9781426814433.jpg?1726617382427",
      "alt": "This image is the cover for the book Frontier Courtship"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Frontier Courtship\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Journey of Hope ")]), _c('br'), _c('br'), _vm._v("She had made a solemn promise to see her younger sister to safety in California. But the endless journey across the frontier was proving to be a heartbreaking test of courage and endurance for Faith Beal. All she had to sustain her was her steadfast belief in a loving Godand the guiding hand of a stranger who truly seemed heaven-sent. "), _c('br'), _c('br'), _c('b', [_vm._v("and Love ")]), _c('br'), _c('br'), _vm._v("Connell McClain was her selfless guardian as their wagon train slowly made its way West. And as they shared the dangers of the trailand the closeness of a covered wagonFaith felt the first tender stirrings of love for this rough-hewn yet caring man. But would the secrets that seemed to haunt him threaten their growing feelings for one another?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Valerie Hansen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Valerie Hansen resides in the rural Ozarks where she writes the books of her heart, primarily for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and has worked as a teacher's-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist, dulcimer builder, Veterinarian's asst., 4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0